import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

import moduleAuth from './auth/moduleAuth.js';
import moduleStats from './stats/moduleStats.js';
import moduleStories from './stories/moduleStories.js';

Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    stats: moduleStats,
    stories: moduleStories
  }
});
